// import axios from "axios";
// import * as actionTypes from "./actionTypes";

import { toast } from "react-toastify";
import {
  responseDataFormat,
  responseDataFormatRedux,
  handleCatchErrors,
  responseDataFormatReduxAuth,
} from "../../middlewares/resolveRequests";
import {
  addCommentData,
  addMessageData,
  addProfilePostData,
  addRoom,
  delPost,
  editPost,
  getEditPostData,
  getMemberLists,
  getPostData,
  getRoom,
  getRooms,
  getUserCounts,
  isRoom,
  refreshToken,
  userApplicant,
  userDataFromToken,
  userDetails,
  userForgetPassword,
  userLogin,
  userLogout,
  userResetPassword,
} from "../../services/userAuth";
import * as actionTypes from "../actions/actionTypes";

// export const authStart = () => {
//   return {
//     type: actionTypes.AUTH_START,
//   };
// };

// export const authSuccess = (authData) => {
//   return {
//     type: actionTypes.AUTH_SUCCESS,
//     authData: authData,
//   };
// };

// export const authFail = (error) => {
//   return {
//     type: actionTypes.AUTH_FAIL,
//     error: error,
//   };
// };

// export const auth = (email, passwords) => {
//   return (dispatch) => {
//     dispatch(authStart());
//   };
// };

export const login = async (userData, setDisable, setContent, setShow) => {
  let response;
  setShow(true);
  try {
    response = await userLogin(userData);
    setDisable(true);
    if (response.status <= 206) {
      setShow(false);
    }
  } catch (e) {
    setDisable(false);
    setContent("دخول");
    setShow(false);
    toast.error("حدث خطا الدخول", {
      position: "top-center",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormatReduxAuth(response, actionTypes.USER_INFO);
  }
};

export const refreshUserToken = async (token) => {
  let response;
  try {
    response = await refreshToken(token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormatReduxAuth(response, actionTypes.USER_INFO);
  }
};

export const getUserData = async (
  userId,
  isAuthentactedState,
  token,
  dispatch
) => {
  let response;
  try {
    response = await userDataFromToken(userId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    dispatch(isAuthentactedState(response.status));

    return responseDataFormatReduxAuth(response, actionTypes.USER_DATA);
  }
};
export const isAuthentactedState = (status) => {
  let response = {
    data: {
      status,
      data: status >= 200 && status <= 206 ? true : false,
    },
  };
  return responseDataFormatReduxAuth(response, actionTypes.AUTHENTICATED);
};
export const register = async (data) => {
  for (let [key, value] of Object.entries(data)) {
  }
  let response;
  try {
    response = await userApplicant(data);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};
export const clearCommunity = () => {
  let response;

  response = {
    status: 200,
    data: null,
  };

  return responseDataFormatRedux(response, actionTypes.COMMUNITY);
};

export const logout = async () => {
  let response;
  try {
    await userLogout();
    response = {
      status: 200,
      data: null,
    };
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    clearCommunity();
    return responseDataFormatRedux(response, actionTypes.LOGOUT);
  }
};

export const forgetPassword = async (email) => {
  let response;
  try {
    response = await userForgetPassword(email);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const resetPassword = async (email, password, token) => {
  let response;
  try {
    response = await userResetPassword(email, password, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const getUserProfileDetails = async (userId, token) => {
  let response;
  try {
    response = await userDetails(userId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export async function getUserCountLength(userId, token) {
  let response;
  try {
    response = await getUserCounts(userId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
}

export async function getProfileToggleLists(userId, componentId, token) {
  let response;
  try {
    response = await getMemberLists(userId, componentId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
}

export const deletePost = async (postId, token) => {
  let response;
  try {
    response = await delPost(postId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const addMessageRoom = async (data, token) => {
  let response;
  try {
    response = await addRoom(data, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const alreadyHaveARoom = async (senderId, RecieverId, token) => {
  let response;
  try {
    response = await isRoom(senderId, RecieverId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export async function getMessageRooms(token) {
  let response;
  try {
    response = await getRooms(token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
}

export async function getMessageRoom(roomId, token) {
  let response;
  try {
    response = await getRoom(roomId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
}

export const addMessage = async (data, token) => {
  let response;
  try {
    response = await addMessageData(data, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const addProfilePost = async (body, token) => {
  let response = null;

  try {
    response = await addProfilePostData(body, token);
  } catch (e) {
    response = e;
    return handleCatchErrors(response);
  } finally {
    return responseDataFormat(response);
  }
};

export const EditPostData = async (postId, token) => {
  let response;
  try {
    response = await getEditPostData(postId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const editPostForm = async (data = {}, token) => {
  let response;
  try {
    response = await editPost(data, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const getPostDetails = async (id, token) => {
  let response = null;

  try {
    response = await getPostData(id, token);
  } catch (e) {
    response = e;
    return handleCatchErrors(response);
  } finally {
    return responseDataFormat(response);
  }
};

export const addPostComment = async (body, token) => {
  let response = null;

  try {
    response = await addCommentData(body, token);
  } catch (e) {
    response = e;
    return handleCatchErrors(response);
  } finally {
    return responseDataFormat(response);
  }
};
